import React, { Fragment, useState } from 'react';
import validate from 'validate.js';

import {
  Grid,
  Container,
  Button,
  TextField,
  ButtonGroup,
  InputAdornment,
  Hidden
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import PlainLink from '../../components/link';
import hero9 from '../../../assets/images/hero-bg/hero-9.jpg';
import { connect } from 'react-redux';
import {
  setRegisterData,
  registerUser,
  resendOtp,
  verifyOtp,
  clearRegisterData
} from '../../reducers/register';
import { CONFIG_OTP_RESEND_ATTEMPTS, USER_TYPE, VALIDATION_MESSAGES } from '../../constants';
import { ROUTES_PATH_CONFIG } from '../../config/routes';
import errorState from './inital_error_state';
import OPTModal from '../../components/modals/otp';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import TermsModal from 'eebac/components/modals/terms';
import Alert from '@material-ui/lab/Alert';

const validators = {
  FirstName: {
    presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    length: { message: VALIDATION_MESSAGES.INVALID, minimum: 2, maximum: 255 },
    format: {
      message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_ALLOWED,
      pattern: /[a-zA-Z]+/
    }
  },
  LastName: {
    presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    length: { message: VALIDATION_MESSAGES.INVALID, minimum: 2, maximum: 255 },
    format: {
      message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_ALLOWED,
      pattern: /[a-zA-Z]+/
    }
  },
  Email: {
    email: {
      message: VALIDATION_MESSAGES.INVALID
    }
  },
  MobileNumber: {
    presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    format: {
      pattern: /^[6-9]\d{9}$/,
      message: VALIDATION_MESSAGES.INVALID
    }
  },
  PasswordCaps: {
    presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    format: {
      pattern: /[A-Z]+/,
      flags: "g",
      message: VALIDATION_MESSAGES.PASSWORD
    }
  },
  PasswordSmall: {
    format: {
      pattern: /[a-z]+/,
      flags: "g",
      message: VALIDATION_MESSAGES.PASSWORD
    }
  },
  PasswordNumbers: {
    format: {
      pattern: /[0-9]+/,
      flags: "g",
      message: VALIDATION_MESSAGES.PASSWORD
    }
  },
  PasswordChars: {
    format: {
      pattern: /[~!@#$%]+/,
      flags: "g",
      message: VALIDATION_MESSAGES.PASSWORD
    }
  }
}

function Register(props) {

  const hisotry = useHistory();

  const {
    setRegisterData,
    userData,
    registerUser,
    resendOtp,
    clearRegisterData,
    verifyOtp
  } = props;

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  const setUserData = (key, value) => {
    if (key == "type") {
      setRegisterData([{ key: key, value: value }, { key: "userTypeError", value: "" }]);
    } else {
      if (value) {
        value = value.trim();
      }
      setRegisterData([{ key: key, value: value }]);
    }
  }

  const onCreateAccount = () => {
    setRegisterData(errorState);
    let isError = false;

    let errorObj = [];

    if (!userData.type) {
      errorObj.push({
        key: 'userTypeError',
        value: "Select type"
      });
      isError = true;
    }

    let errorMessage = validate.single(userData.firstName, validators.FirstName, { format: "flat" });
    if (errorMessage && errorMessage.length > 0) {
      errorObj.push({
        key: 'firstNameError',
        value: errorMessage[0]
      });

      isError = true;
    }

    errorMessage = validate.single(userData.lastName, validators.LastName, { format: "flat" });
    if (errorMessage && errorMessage.length > 0) {
      errorObj.push({
        key: 'lastNameError',
        value: errorMessage[0]
      });

      isError = true;
    }

    errorMessage = validate.single(userData.email, validators.Email, { format: "flat" });
    if (errorMessage && errorMessage.length > 0) {
      errorObj.push({
        key: 'emailError',
        value: errorMessage[0]
      });

      isError = true;
    }

    errorMessage = validate.single(userData.mobileNumber, validators.MobileNumber, { format: "flat" });
    if (errorMessage && errorMessage.length > 0) {
      errorObj.push({
        key: 'mobileNumberError',
        value: errorMessage[0]
      });

      isError = true;
    }

    if (!validators.PasswordCaps.format.pattern.test(userData.password) ||
      !validators.PasswordSmall.format.pattern.test(userData.password) ||
      !validators.PasswordNumbers.format.pattern.test(userData.password) ||
      !validators.PasswordChars.format.pattern.test(userData.password) || userData.password.length < 8 ||
      userData.password.length > 16
    ) {
      errorObj.push({
        key: 'passwordError',
        value: validators.PasswordCaps.format.message
      });

      isError = true;
    }

    if (isError) {
      setRegisterData(errorObj);
    } else {
      registerUser();
    }

  }

  const setMobileOTP = (otp) => {
    if (/^[0-9]{1,6}$/.test(otp) || !otp) {
      setRegisterData([
        { key: "mobileOTP", value: otp }
      ]);
    }
  }

  const setEmailOTP = (otp) => {
    if (/^[0-9]{1,6}$/.test(otp) || !otp) {
      setRegisterData([
        { key: "emailOTP", value: otp }
      ]);
    }
  }

  const onOPTModalClose = () => {
    setRegisterData([
      { key: "openOTPModal", value: false },
      { key: "emailOTPResendAttemps", value: CONFIG_OTP_RESEND_ATTEMPTS },
      { key: "mobileOTPResendAttemps", value: CONFIG_OTP_RESEND_ATTEMPTS },
      { key: "emailOTP", value: '' },
      { key: "mobileOTP", value: '' },
      { key: "emailOtpProcessing", value: false },
      { key: "mobileOtpProcessing", value: false },
      { key: "emailOtpVerified", value: false },
      { key: "emailOtpResent", value: false },
      { key: "mobileOtpVerified", value: false },
      { key: "mobileOtpResent", value: false },
      { key: "emailOtpError", value: '' },
      { key: "mobileOtpError", value: '' },
      { key: "userTypeError", value: '' }
    ]);
  }

  const onEmailOTPVerify = () => {
    if (userData.emailOtpProcessing || userData.emailOtpVerified) {
      return false;
    }

    if (!(/^[0-9]{6}$/.test(userData.emailOTP))) {
      setRegisterData([
        { key: "emailOtpError", value: VALIDATION_MESSAGES.INVALID }
      ]);

      return false;
    }

    return true;
  }

  const onEmailOTPResend = () => {
    if (userData.emailOtpProcessing || userData.emailOtpVerified) {
      return;
    }

    resendOtp(true);
  }

  const onMobileOTPVerify = () => {
    if (userData.mobileOtpProcessing || userData.mobileOtpVerified) {
      return false;
    }

    if (!(/^[0-9]{6}$/.test(userData.mobileOTP))) {
      setRegisterData([
        { key: "mobileOtpError", value: VALIDATION_MESSAGES.INVALID }
      ]);

      return false;
    }

    return true;
  }

  const onMobileOTPResend = () => {
    if (userData.mobileOtpProcessing || userData.mobileOtpVerified) {
      return;
    }

    resendOtp(false);
  }

  const onOTPVerify = () => {
    let emailOtp = true; // onEmailOTPVerify();
    let mobileOtp = onMobileOTPVerify();

    if (emailOtp && mobileOtp) {
      verifyOtp();
    }
  }

  const onSigninClick = () => {
    clearRegisterData();
    hisotry.push(ROUTES_PATH_CONFIG.APP.signin);
  }

  if (userData.emailOtpVerified && userData.mobileOtpVerified) {
    setTimeout(onSigninClick, 5000);
  }

  const onTermsClose = () => {
    setRegisterData([
      { key: "openTerms", value: false }]);
  }

  const onTermsOpen = () => {
    setRegisterData([
      { key: "openTerms", value: true }]);
  }

  return (
    <Fragment>
      <Fragment>
        {userData.openTerms && <TermsModal onClose={onTermsClose} open={true} />}
        {userData.openOTPModal &&
          <OPTModal onClose={onOPTModalClose} open={true}
            setMobileOTP={setMobileOTP} setEmailOTP={setEmailOTP}
            onEmailOTPVerify={onEmailOTPVerify} onEmailOTPResend={onEmailOTPResend}
            onMobileOTPVerify={onMobileOTPVerify} onMobileOTPResend={onMobileOTPResend}

            emailOTPResendAttemps={userData.emailOTPResendAttemps}
            mobileOTPResendAttemps={userData.mobileOTPResendAttemps}

            emailOTP={userData.emailOTP}
            mobileOTP={userData.mobileOTP}

            emailOTPError={userData.emailOtpError}
            mobileOTPError={userData.mobileOtpError}

            emailOtpVerified={userData.emailOtpVerified}
            mobileOtpVerified={userData.mobileOtpVerified}

            emailOtpProcessing={userData.emailOtpProcessing}
            mobileOtpProcessing={userData.mobileOtpProcessing}
            onOTPVerify={onOTPVerify}
            showEmailOtpBox={false}
          />
        }

        <div className="app-wrapper min-vh-100 bg-white">
          <div className="app-main min-vh-100">
            <div className="app-content p-0">
              <div className="app-inner-content-layout--main">
                <div className="flex-grow-1 w-100 d-flex align-items-center">
                  <div className="bg-composed-wrapper--content">
                    <Grid container spacing={0} className="min-vh-100">
                      <Hidden smDown>
                        <Grid
                          item
                          xs={12}
                          md={4}
                          lg={5}
                          className="d-flex align-items-center">
                          <div className="hero-wrapper w-100 bg-composed-wrapper bg-plum-plate min-vh-100 h-100">
                            <div className="flex-grow-1 w-100 d-flex align-items-center">
                              <div
                                className="bg-composed-wrapper--image"
                                style={{ backgroundImage: 'url(' + hero9 + ')' }}
                              />
                              <div className="bg-composed-wrapper--bg bg-premium-dark opacity-5" />
                              <div className="bg-composed-wrapper--content p-5">
                                <div className="text-white mt-3">

                                  <div className="card-header--title py-2 font-size-lg font-weight-bold text-center">
                                    <div>
                                      <a href="/">
                                        <img alt="eebac.com" src="/images/logo.png" style={{ width: "160px" }} />
                                      </a>
                                    </div>
                                   Create an account
                                   <div>Already have an account? <PlainLink color="primary"
                                      onClick={onSigninClick}
                                      className="m-2 text-primary px-0">
                                      <span className="font-size-lg">Sign In</span>
                                    </PlainLink></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </Hidden>
                      <Grid
                        item
                        xs={12}
                        md={8}
                        lg={7}
                        className="d-flex align-items-center" style={{ padding: "50px 0px" }}>
                        <Container maxWidth="sm">
                          <Hidden mdUp>
                            <div style={{ marginTop: "-50px" }} className="card-header--title py-2 font-size-lg font-weight-bold text-center">
                              <a className="py-2" href="/">
                                <img alt="eebac.com" src="/images/logo.png" style={{ width: "160px" }} />
                              </a>
                            </div>
                          </Hidden>
                          <div className="mb-3">
                            <ButtonGroup aria-label="small outlined button group"
                              style={userData.userTypeError ? { border: "1px solid red" } : {}}>
                              <Button onClick={() => setUserData('type', USER_TYPE.COMPANY)}
                                color={userData.type === "company" ? "primary" : ""}
                                variant={userData.type === "company" ? "contained" : ""}
                              >Builders / Developers</Button>

                              <Button onClick={() => setUserData('type', USER_TYPE.VENDOR)}
                                color={userData.type === "vendor" ? "primary" : ""}
                                variant={userData.type === "vendor" ? "contained" : ""}>Contractors</Button>
                            </ButtonGroup>
                            {userData.userTypeError && <Alert style={{
                              background: "none",
                              padding: "0", paddingLeft: "5px", color: "red"
                            }}
                              icon={false} severity="error">Select Type</Alert>}
                          </div>
                          <Grid container spacing={4}>
                            <Grid item xs={12} lg={6} style={{ padding: "0px 16px" }}>
                              <div className="mb-2">
                                <TextField
                                  error={userData.firstNameError ? true : false}
                                  helperText={userData.firstNameError}
                                  fullWidth
                                  className="m-2"
                                  label="First name"
                                  value={userData.firstName}
                                  onChange={(e) => { setUserData('firstName', e.target.value) }}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} lg={6} style={{ padding: "0px 16px 16px" }}>
                              <div className="mb-2">
                                <TextField
                                  error={userData.lastNameError ? true : false}
                                  helperText={userData.lastNameError}
                                  fullWidth
                                  className="m-2"
                                  label="Last name"
                                  value={userData.lastName}
                                  onChange={(e) => { setUserData('lastName', e.target.value) }}
                                />
                              </div>
                            </Grid>
                          </Grid>

                          <div className="mb-2">
                            <TextField
                              error={userData.emailError ? true : false}
                              helperText={userData.emailError}
                              fullWidth
                              className="m-2"
                              label="Email address"
                              value={userData.email}
                              onChange={(e) => { setUserData('email', e.target.value) }}
                            />
                          </div>

                          <div className="mb-2">
                            <TextField
                              error={userData.mobileNumberError ? true : false}
                              helperText={userData.mobileNumberError}
                              fullWidth
                              className="m-2"
                              label="Mobile number"
                              value={userData.mobileNumber}
                              onChange={(e) => { setUserData('mobileNumber', e.target.value) }}
                            />
                          </div>

                          <div className="mb-2">
                            <TextField
                              error={userData.passwordError ? true : false}
                              helperText={userData.passwordError}
                              label="Password"
                              className="m-2"
                              fullWidth
                              type={showPassword ? 'text' : 'password'}

                              value={userData.password}
                              onChange={(e) => { setUserData('password', e.target.value) }}

                              InputProps={{
                                endAdornment: <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                              }}
                            />
                          </div>

                          <div className="form-group pt-2 mb-4">
                            By clicking the <strong>Create account</strong>{' '}
                            button below you agree to our <PlainLink onClick={onTermsOpen} color="primary" className="m-2 text-primary px-0">
                              Terms of Service
                            </PlainLink> and <PlainLink onClick={onTermsOpen} color="primary"
                              className="m-2 text-primary px-0">Privacy</PlainLink> statement.
                          </div>

                          <div className="text-center">
                            <Button
                              color="primary"
                              size="large"
                              variant="contained"
                              className="mb-2" onClick={onCreateAccount}>
                              Create Account
                          </Button>
                            <div>Already have an account? <PlainLink color="primary"
                              onClick={onSigninClick}
                              className="m-2 text-primary px-0">
                              <span style={{ marginBottom: "3px" }} className="font-size-sm">Sign In</span>
                            </PlainLink></div>
                          </div>
                        </Container>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>

    </Fragment >
  );
}


const mapStateToProps = state => ({
  userData: state.REGISTER_DATA,
});

const mapDispatchToProps = dispatch => ({
  setRegisterData: data => dispatch(setRegisterData(data)),
  registerUser: () => dispatch(registerUser()),
  resendOtp: (isEmail) => dispatch(resendOtp(isEmail)),
  verifyOtp: () => dispatch(verifyOtp()),
  clearRegisterData: () => dispatch(clearRegisterData())
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);